<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path d="M14,7A7,7,0,1,1,7,0,7,7,0,0,1,14,7Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" transform="translate(1.5 1.5)" />
        <path d="M0,0V4H4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" transform="translate(8.5 4.5)" />
      </g>
    </g>
  </svg>
</template>
